<div class="header">
  <h2>Inbox</h2>
</div>
<mat-card>
  <table mat-table [dataSource]="outgoingMessageList?.results" matTableResponsive class="full-width">
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef>
        No.
      </th>
      <td mat-cell *matCellDef="let i=index">
        {{i+1 + pageOffset}}
      </td>
    </ng-container>
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>
        Title
      </th>
      <td mat-cell *matCellDef="let record">
        <span *ngIf="record.notification_event_detail">
          {{record.notification_event_detail.title}}
        </span>
        <span *ngIf="!record.notification_event_detail">
          {{'-'}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="subject">
      <th mat-header-cell *matHeaderCellDef>
        Subject
      </th>
      <td mat-cell *matCellDef="let record">
        {{record.subject}}
      </td>
    </ng-container>
    <ng-container matColumnDef="message-type">
      <th mat-header-cell *matHeaderCellDef>
        Message Type
      </th>
      <td mat-cell *matCellDef="let record">
        {{record.outgoing_message_type_display}}
      </td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>
        Status
      </th>
      <td mat-cell *matCellDef="let record">
        {{record.status_display}}
      </td>
    </ng-container>
    <ng-container matColumnDef="recipient">
      <th mat-header-cell *matHeaderCellDef>
        Recipient
      </th>
      <td mat-cell *matCellDef="let record">
        {{record.recipient}}
      </td>
    </ng-container>
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>
        Date
      </th>
      <td mat-cell *matCellDef="let record">
        {{record.created_time | date: 'MM/dd/yyyy'}}
      </td>
    </ng-container>
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>
        Action
      </th>
      <td mat-cell *matCellDef="let record">
        <button mat-stroked-button color="primary" (click)="getMessageDetail(record.id)">Detail</button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator [length]="outgoingMessageList?.count" (page)="onPaginationChange($event)" [pageIndex]="pageIndex"
    [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>
</mat-card>

<ng-template #outgoingMessageDetail>
  <div class="align-right">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>

  <div class="message-info" *ngIf="messageDetail">
    <p class="date">{{messageDetail.created_time | date:'mediumDate'}}</p>
    <p class="subject">{{messageDetail.subject}}</p>
    <!-- <p class="title">{{messageDetail.notification_event_detail?.title}}</p> -->
    <p [innerHtml]="messageDetail.notification_event_detail?.rendered_content || messageDetail.notification_event_detail?.template_detail?.rendered_content"></p>
    <!-- <p class="title">{{messageDetail.notification_event_detail?.template_detail?.title}}</p> -->
    <!-- <p [innerHtml]="messageDetail.notification_event_detail?.template_detail?.content"></p> -->
  </div>

</ng-template>
